import React from 'react'
import { map, get } from 'lodash'
import { PaymentMethod } from '~/components/payment'
import { __ } from '~/i18n'

export default class GratifyMethod extends React.PureComponent {
  render() {
    const { data, paymentMethod, active, selectMethod, args, showProvider } = this.props;

    if(!data) {
      return null;
    }

    const selectedMethodKey = get(args, 'key');

    return map(data, (method) => {
      let props = {};
      const methodSelected = active && (selectedMethodKey === method.key);

      if(method.logo_url) {
        props.image = method.logo_url
      }else {
        props.name = method.title.toUpperCase()
      }

      if(showProvider) {
        props.extra = __('Gratify')
      }
      return (
        <PaymentMethod
          key={ method.title }
          active={ methodSelected }
          {...props}
          selectMethod={ () => {
            selectMethod(paymentMethod, method);
          }}
        />
      )
    })
  }
}
